var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', [_c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "sm": "12",
      "md": "auto"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "dense": ""
    },
    model: {
      value: _vm.target,
      callback: function callback($$v) {
        _vm.target = $$v;
      },
      expression: "target"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "\uC120\uD0DD\uB41C \uC0AC\uC6A9\uC790\uC5D0\uAC8C \uBC1C\uC1A1[".concat(_vm.value.length, "\uBA85]"),
      "value": "selected"
    }
  }), _c('v-radio', {
    attrs: {
      "label": "\uAC80\uC0C9\uB41C \uC0AC\uC6A9\uC790\uC5D0\uAC8C \uBC1C\uC1A1[".concat(_vm.summary.totalCount.format(), "\uBA85]"),
      "value": "search"
    }
  })], 1)], 1), _c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "메일 제목",
      "persistent-placeholder": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.subject,
      callback: function callback($$v) {
        _vm.subject = $$v;
      },
      expression: "subject"
    }
  }), _c('v-textarea', {
    staticClass: "mt-3",
    attrs: {
      "label": "메일 내용",
      "persistent-placeholder": "",
      "hide-details": "",
      "outlined": ""
    },
    model: {
      value: _vm.html,
      callback: function callback($$v) {
        _vm.html = $$v;
      },
      expression: "html"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "mt-8",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("발송")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }